import { useEffect, useState } from "react";
import { Languages, Loader2 } from "lucide-react";
import api from "@/lib/api";

// Traduce automaticamente un array di stringhe nella lingua target via /public/translate,
// batchando in un'unica richiesta (cache condivisa lato backend). Con target 'it' o
// array vuoto ritorna le sorgenti invariate.
export function useAutoTranslate(texts, targetLang) {
  const key = JSON.stringify(Array.isArray(texts) ? texts : []);
  const [state, setState] = useState(() => ({ translated: Array.isArray(texts) ? texts : [], translating: false }));

  useEffect(() => {
    const arr = JSON.parse(key);
    const hasContent = arr.some((t) => (t || "").trim());
    if ((targetLang || "it") === "it" || !hasContent) {
      setState({ translated: arr, translating: false });
      return;
    }
    let cancelled = false;
    setState((s) => ({ translated: s.translated, translating: true }));
    api.post("/public/translate", { texts: arr, target_lang: targetLang })
      .then(({ data }) => {
        if (cancelled) return;
        const tr = data.translations || [];
        setState({ translated: arr.map((t, i) => tr[i] ?? t), translating: false });
      })
      .catch(() => { if (!cancelled) setState({ translated: arr, translating: false }); });
    return () => { cancelled = true; };
  }, [key, targetLang]);

  return state;
}

// Badge "tradotto automaticamente" (icona Languages) / "traduzione in corso…" (spinner).
export function AutoTranslatedBadge({ translating, labels, testId }) {
  return (
    <div className="flex items-center gap-1.5 text-[11px] font-medium text-brand" data-testid={testId}>
      {translating
        ? <><Loader2 className="h-3 w-3 animate-spin" /> {labels.translating}</>
        : <><Languages className="h-3 w-3" /> {labels.auto_translated}</>}
    </div>
  );
}
